import React, {useEffect} from "react";
import t, {changeLanguage} from "../../components/I18N/TranslateHelpers";
import {GetCurrentLocale} from "../../components/Utils";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../app/RootReducer";
import {LocalParams} from "../../components/LocalParams";
import {getCart} from "../Cart/CartSlice";

const IconsProfileCartBlock = () => {
  const locale = GetCurrentLocale();
  changeLanguage(locale)

  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const tokenCart = LocalParams.getItem('tokenCart') as string
  const dispatch = useDispatch();
  const itemsInCart = useSelector((state: RootState) => state.cartRdc.cart )
  const itemsInCartOffer = useSelector((state: RootState) => state.cartOfferRdc.offerCart);

  let hasItemsInCart = false
  let hasItemsInCartOffer = false

  if(itemsInCartOffer && itemsInCartOffer.items.length > 0){
    hasItemsInCartOffer = true
  }
  if(itemsInCart && itemsInCart.items && itemsInCart.items.length > 0){
    hasItemsInCart = true
  }

  useEffect(() => {
      if(tokenCart){
        dispatch(getCart(tokenCart));
      }
    }, []
  );
  return (
    <div className="widgets-wrap float-md-end text-center">
      <div className="widget-header mx-2">
        {
          isAuthenticated ?
            <a href={"/" + locale + t('url_profile')} className="widget-icontop">
              <div className="icon-area">
                <i className="fa fa-user"/>
              </div>
              <p className="text mb-0"> { t('profile')} </p>
            </a>
            :
            null
        }
      </div>
      <div className="widget-header mx-2">
        <a href={hasItemsInCart ? "/" + locale + t('url_cart') : hasItemsInCartOffer ? "/" + locale + t('url_request_offer') : "/" + locale + t('url_cart')} className="widget-icontop">
          <div className="icon-area">
            {
              itemsInCart ?
              <span className="number-cart">{itemsInCart.items.length}</span>
               :
              null
            }
            <i className="fa fa-shopping-cart"/>
          </div>
          {
            hasItemsInCart ?
              <p className="text mb-0"> { t('cart') } </p>
              : hasItemsInCartOffer ?
                <p className="text mb-0"> { t('my_offer_request') } </p>
                : <p className="text mb-0"> { t('cart') } </p>
          }

        </a>
      </div>
    </div>
  )
}
export default IconsProfileCartBlock;
